import * as A from '../admin'
import {PostBlockConfig} from './meta'

export const Admin: A.Admin<PostBlockConfig> = () => null
